"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAutocomplete = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.StyledAutocomplete = (0, styled_components_1.default)(ui_components_1.Autocomplete) `
  min-width: ${(props) => props.theme.spacing(31.25)};
`;
